"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeSeNok = exports.SeSeDkk = exports.SeSeSek = exports.SvSeUsd = exports.SvSeNok = exports.SvSeDkk = exports.SvSeSek = exports.SvSeEur = exports.EnSeUsd = exports.EnSeNok = exports.EnSeDkk = exports.EnSeSek = exports.EnSeEur = void 0;
class EnSeEur {
    constructor() {
        this.locale = "en-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnSeEur = EnSeEur;
class EnSeSek {
    constructor() {
        this.locale = "en-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "SEK",
            symbol: "SEK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnSeSek = EnSeSek;
class EnSeDkk {
    constructor() {
        this.locale = "en-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "DKK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnSeDkk = EnSeDkk;
class EnSeNok {
    constructor() {
        this.locale = "en-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "NOK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnSeNok = EnSeNok;
class EnSeUsd {
    constructor() {
        this.locale = "en-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnSeUsd = EnSeUsd;
class SvSeEur {
    constructor() {
        this.locale = "sv-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "'den 'd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.SvSeEur = SvSeEur;
class SvSeSek {
    constructor() {
        this.locale = "sv-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "'den 'd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "SEK",
            symbol: "kr",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SvSeSek = SvSeSek;
class SvSeDkk {
    constructor() {
        this.locale = "sv-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "'den 'd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "kr",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SvSeDkk = SvSeDkk;
class SvSeNok {
    constructor() {
        this.locale = "sv-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "'den 'd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "kr",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SvSeNok = SvSeNok;
class SvSeUsd {
    constructor() {
        this.locale = "sv-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "'den 'd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SvSeUsd = SvSeUsd;
class SeSeSek {
    constructor() {
        this.locale = "se-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM d'. b. 'yyyy",
        };
        this.currencyFormat = {
            code: "SEK",
            symbol: "kr",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SeSeSek = SeSeSek;
class SeSeDkk {
    constructor() {
        this.locale = "se-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM d'. b. 'yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "kr",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SeSeDkk = SeSeDkk;
class SeSeNok {
    constructor() {
        this.locale = "se-se";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM d'. b. 'yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "kr",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.SeSeNok = SeSeNok;
